/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trace_Code_Dialog_TitleInputs */

const vi_trace_code_dialog_title = /** @type {(inputs: Trace_Code_Dialog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã truy xuất nguồn gốc`)
};

/**

* @param {Trace_Code_Dialog_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trace_code_dialog_title = /** @type {((inputs?: Trace_Code_Dialog_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trace_Code_Dialog_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trace_code_dialog_title(inputs)
});